var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRatingSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  fill: "none",
  viewBox: "0 0 22 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD702",
  stroke: "#FFD702",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m14.63 6.341 7.231 1.023-5.233 4.934 1.235 6.969-6.468-3.292-6.468 3.292 1.235-6.97L.929 7.365 8.16 6.341 11.395 0z"
})));
export default SvgRatingSmall;